import React from "react"

import { IDomain } from "@mono/essentials/types/UserTypes"

import CustomWidgetPreview from "./CustomWidgetPreview"

const DefaultWidgetPreview = ({
  isIntegratedPage,
  domainDetails,
  nextStep,
}: {
  isIntegratedPage?: boolean
  domainDetails?: IDomain
  nextStep?: string
}) => {
  const data = {
    widget_type: "product_list",
    show_product_list_for: "all_products",
    display_category_as: "tab",
    showProductDescription: true,
    display_default_category_as: "",
  }
  return (
    <CustomWidgetPreview
      data={data}
      isIntegratedPage={isIntegratedPage}
      domainDetails={domainDetails}
      nextStep={nextStep}
    />
  )
}

export default DefaultWidgetPreview
